<template>
  <div class="integration-base">
    <AppSelect
      v-model="selected"
      class="select-add-button block"
      popup-content-class="select-add-button-content"
      option-value="id"
      option-label="title"
      :options="autoresponders"
      :rules="[$options.rules.REQUIRED]"
      emit-value
      map-options
    >
      <template #before-options>
        <div class="btn-block">
          <AppButton
            :label="$t('button.addNewAutoresponder')"
            class="text-14-400"
            text-color="black"
            padding="3px 16px"
            @click="showCreateDialog = true"
          />
        </div>
      </template>
      <template v-slot:no-option>
        <div class="btn-block">
          <AppButton
            :label="$t('button.addNewAutoresponder')"
            class="text-14-400"
            text-color="black"
            padding="3px 16px"
            @click="showCreateDialog = true"
          />
        </div>
      </template>
      <template v-slot:selected-item="{ opt }">
        <div class="selected-option">
          <q-img
            v-if="opt.type"
            :src="require(`common/assets/${opt.type}.svg`)"
            width="16px"
          />
          {{ opt.title }}
        </div>
      </template>
      <template v-slot:option="scope">
        <div
          class="option"
          v-on="scope.itemEvents"
        >
          <div class="option-inner">
            <div class="option-label">
              <q-img
                :src="require(`common/assets/${scope.opt.type}.svg`)"
                width="16px"
              />
              {{ scope.opt.title }}
            </div>
          </div>
        </div>
      </template>
      <template #after>
        <q-icon
          name="fl:trash"
          color="grey"
          class="cursor-pointer q-pt-md"
          size="14px"
          @click="showRemoveConfirmation = true"
        />
      </template>
    </AppSelect>

    <slot/>

    <AttentionDialog
      :is-open="showRemoveConfirmation"
      :title="$t('title.attention')"
      @close="showRemoveConfirmation = false"
    >
      <div class="row justify-center">
        <div class="col-8">
          <div class="text-19-400 text-center q-py-lg">
            {{ $t('text.deleteAutoresponderConfirm') }}
          </div>
        </div>
      </div>
      <template #footer>
        <AppButton
          v-close-popup
          class="col-4"
          :label="$t('button.no')"
        />
        <AppButton
          v-close-popup
          icon-right="fl:trash"
          class="col"
          color="white"
          text-color="black"
          :label="$t('button.delete')"
          outline
          @click="$emit('remove')"
        />
      </template>
    </AttentionDialog>
    <NewProviderDialog
      :is-open="showCreateDialog"
      :options="$options.autoresponderOptions"
      :title="$t('title.addAutoresponders')"
      :select-label="$t('label.autoresponders')"
      :submit-label="$t('button.addAutoresponder')"
      :create-fn="createAutoresponder"
      @close="showCreateDialog = false"
    />
  </div>
</template>

<script>
import AppSelect from 'common/components/AppSelect';
import AppButton from 'common/components/buttons/AppButton';
import AttentionDialog from 'common/components/dialogs/AttentionDialog';
import autoresponderOptions from 'common/helpers/data/autoresponders';
import rules from 'common/helpers/rules';
import NewProviderDialog from 'common/pages/dashboard/components/NewProviderDialog';
import { mapActions, mapState } from 'vuex';

export default {
  name: 'AutoresponderItem',
  rules,
  autoresponderOptions,
  components: {
    AttentionDialog,
    AppButton,
    AppSelect,
    NewProviderDialog,
  },
  props: {
    value: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      showRemoveConfirmation: false,
      showCreateDialog: false,
      selected: undefined,
    };
  },
  computed: {
    ...mapState('dashboard', ['autoresponders']),
  },
  watch: {
    value: {
      immediate: true,
      handler() {
        this.selected = this.value.autoresponderProviderId;
      },
    },
    selected() {
      this.$emit('input', {
        ...this.value,
        autoresponderProviderId: this.selected,
        data: {
          type: this.autoresponders.find(({ id }) => id === this.selected).type,
        },
      });
    },
  },
  methods: {
    ...mapActions('dashboard', ['createAutoresponder']),
  },
};
</script>

<style scoped lang="scss">
.integration-base {
  display: flex;
  gap: 20px;
  flex-direction: column;

  ::v-deep .integration {
    display: flex;
    flex-direction: column;
    gap: 20px;

    .provider-field {
      display: grid;
      grid-template-columns: 1fr 2fr;
      align-items: center;
      gap: 20px;

      &_day-cycle {
        grid-template-columns: 1fr 2fr 59px;
      }

      .app-input,
      .app-select {
        display: unset;
      }
    }
  }
}
</style>
